import { Seo } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { Fade, Mask } from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";

const h2 = "mt-12 text-xl font-bold uppercase tracking-tight sm:text-2xl";
const p = "mt-4 max-w-3xl text-base leading-relaxed text-mute";

export default function MentionsLegales() {
  return (
    <main id="contenu" className="mx-auto max-w-[1600px] px-5 pb-28 pt-32 sm:px-10 sm:pt-44 lg:px-16">
      <Seo
        title="Mentions légales & confidentialité | SONOCO EVENTS"
        description="Mentions légales et politique de confidentialité du site SONOCO EVENTS, prestataire technique événementiel basé à Fréjus, Var."
        path="/mentions-legales"
      />
      <SectionLabel num="—" name="Mentions légales" />
      <h1 className="mt-10 text-[clamp(2.6rem,8vw,7rem)] font-extrabold uppercase leading-[0.88] tracking-tightest">
        <Mask>Informations légales.</Mask>
      </h1>

      <Fade className="mt-6 max-w-3xl space-y-4" delay={0.1}>
        <h2 className={h2}>Éditeur du site</h2>
        <p className={p}>
          SONOCO EVENTS — Production technique événementielle.
          <br />
          {SITE.location}
          <br />
          E-mail : {SITE.email} — Téléphone : {SITE.phones.join(" / ")}
        </p>
        <p className={p}>
          [À compléter lors de la mise en ligne : forme juridique, SIRET, adresse postale complète,
          n° de TVA intracommunautaire.]
        </p>

        <h2 className={h2}>Hébergement</h2>
        <p className={p}>
          Site hébergé sur OVHcloud, France. [À compléter lors de la mise en ligne : coordonnées de
          l'hébergeur.]
        </p>

        <h2 className={h2} id="rgpd">
          Politique de confidentialité — RGPD
        </h2>
        <p className={p}>
          Les données transmises via le formulaire de contact (nom, société, coordonnées, contenu du
          message) sont utilisées exclusivement pour traiter votre demande. Elles ne sont jamais
          transmises à des tiers ni utilisées à des fins commerciales.
        </p>
        <p className={p}>
          Conformément au Règlement général sur la protection des données (RGPD) et à la loi
          « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification,
          d'opposition et de suppression des données vous concernant. Pour exercer ces droits :
          {SITE.email}.
        </p>

        <h2 className={h2}>Crédits</h2>
        <p className={p}>
          Visuels d'illustration : banques d'images professionnelles (Unsplash). [À remplacer par
          les visuels des productions SONOCO EVENTS lors de la publication des réalisations.]
        </p>
      </Fade>
    </main>
  );
}
